import type { LoadProgress } from '@alrimal/engine';
import { useLocale } from '../LocaleContext.tsx';

/**
 * Progress, not a spinner.
 *
 * A determinate bar over a known file count is honest and it makes a slow
 * connection feel finite. The veil disappears the moment the phase goes idle,
 * including when it goes idle because the load was aborted.
 */
export function LoadingVeil({ progress }: { progress: LoadProgress | null }) {
  const { t } = useLocale();
  if (progress === null || progress.phase === 'idle') return null;

  const ratio =
    progress.total > 0 ? Math.min(1, progress.loaded / progress.total) : 0;

  return (
    <div className="veil" role="status" aria-live="polite">
      <p className="veil__label">
        {progress.phase === 'masterplan'
          ? t('loading.masterplan')
          : t('loading.unit')}
      </p>
      <div
        className="veil__bar"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={progress.total}
        aria-valuenow={progress.loaded}
      >
        <div
          className="veil__fill"
          style={{ inlineSize: `${(ratio * 100).toFixed(0)}%` }}
        />
      </div>
    </div>
  );
}
